export function waitForElementSize(el: HTMLElement, signal?: AbortSignal): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
        if (!document.contains(el)) {
            reject(new Error("[waitForElementSize] element not in DOM"));
            return;
        }

        const getSize = () => {
            const rect = el.getBoundingClientRect();

            if (rect.width > 0 && rect.height > 0) {
                return { width: rect.width, height: rect.height };
            }

            return null;
        };

        const initialSize = getSize();

        if (initialSize) {
            resolve(initialSize);
            return;
        }

        const cleanup = () => {
            ro.disconnect();
            signal?.removeEventListener("abort", onAbort);
        };

        const onAbort = () => {
            cleanup();
            reject(new Error("[waitForElementSize] aborted"));
        };

        const ro = new ResizeObserver(() => {
            const size = getSize();

            if (size) {
                cleanup();
                resolve(size);
            }
        });

        signal?.addEventListener("abort", onAbort, { once: true });
        ro.observe(el);
    });
}
